import type {
  PositionTransform,
  PositionTransformCtx,
} from '../extensions/index.js';
import type { BarState } from '../extensions/types.js';

/**
 * Default no-op transform. Ensures the position pipeline always has at
 * least one entry so call-sites exercise the iteration path in production.
 */
export class IdentityPositionTransform implements PositionTransform {
  readonly id = 'streamlain.gantt.transform.identity';
  readonly priority = 0;

  transform(state: BarState, _ctx: PositionTransformCtx): BarState {
    return state;
  }
}
